import { action } from '@ember/object';

import SheetSelection from 'webapp/utils/sheet-selection';

import type { ColorSelection } from 'webapp/components/custom-query/setup/sheet/preview';
import CustomQuerySetupSheetPreviewComponent from 'webapp/components/custom-query/setup/sheet/preview';

import CustomMetricSetupFormItemField from 'webapp/models-custom/custom-metric-setup-form/item/field';

export default class CustomQuerySetupSheetDataComponent extends CustomQuerySetupSheetPreviewComponent {
	override get activeColorSelections(): ColorSelection[] {
		// filter out only for this activeSheet
		const colorSelections: ColorSelection[] = [];
		this.args.model.colorSelections.forEach((s) => {
			const sheetSelection = SheetSelection.fromA1(s.range);
			if (sheetSelection.a1Prefix === this.activeSheet.sheetPrefix) {
				colorSelections.push(s);
			}
		});
		return colorSelections;
	}

	override setInitialActiveSheet(): void {
		let initialSelectedSheet;

		// initial sheet is the one selected in first a1 field
		const a1Field = this.args.model.items.find(
			(i) => i instanceof CustomMetricSetupFormItemField && i.isA1,
		) as CustomMetricSetupFormItemField;
		if (a1Field?.value) {
			const sheetSelection = SheetSelection.fromA1(a1Field.value as string);
			let sheetId = sheetSelection.a1Prefix;
			if (sheetId) {
				// now it's in format "'Sheet Name'!", remove exclamation mark and single quotes
				sheetId = sheetId.substring(1);
				sheetId = sheetId.substring(0, sheetId.length - 2);
				initialSelectedSheet = this.allSheets.find((item) => item.id === sheetId);
			}
		}

		if (!initialSelectedSheet) {
			initialSelectedSheet = this.allSheets[0];
		}

		if (initialSelectedSheet) {
			this.setActiveSheet(initialSelectedSheet);
		}
	}

	@action
	override markSheetDataFocused(): void {
		this.args.model.handleItemAction('sheetData', 'focus-in');
	}

	@action
	override selectionEnd(a1: string): void {
		const a1WithPrefix = this.activeSheet.sheetPrefix + a1;
		this.args.model.onA1Selected(a1WithPrefix);
	}

	@action
	override selectedValueChange(cellValue: string): void {
		this.selectedCellValue = cellValue;
	}
}
